import zsmLayout from '@/zsm-layout'

const statisticsRouter = {
  path: '/statistics',
  component: zsmLayout,
  name: 'statistics',
  children: [
    {
      path: '/complaints/index',
      component: () => import('@/view/complaints/index'),
      name: 'complaintsStatistics'
    },
    {
      path: '/statistics',
      component: () => import('@/view/statistics/index'),
      name: 'statistics',
      meta: {
        title: '数据统计', icon: 'chart', affix: true,
        childList: [
          { meta: { title: '资金收益' }, title: '资金收益', path: '/statistics/funds' },
          { meta: { title: '订单统计' }, title: '订单统计', path: '/statistics/order'}
          // { meta: { title: '收益提现' }, title: '收益提现', path: '/fund/withdraw' }
          // { meta: { title: '订单统计' }, title: '订单统计', path: '/statistics/order' }
          // { meta: { title: '流量和转换' }, title: '流量和转换', path: '/statistics/flow' },
          // { meta: { title: '兼职小店' }, title: '兼职小店', path: '/statistics/shop' }
        ]
      },
      redirect: '/statistics/funds',
      children: [

        {
          path: '/statistics/funds',
          component: () => import('@/view/statistics/funds'),
          name: 'orderStatistics',
          hidden: true
        },

        {
          path: '/statistics/order',
          component: () => import('@/view/statistics/order'),
          name: 'statisticsOrderInfo',
          hidden: true
        },
        {
          path: '/order/offline',
          component: () => import('@/view/order/offlineIndex'),
          name: 'orderStatistics',
          hidden: true,
          redirect:'/order/offline/list',
          children: [
            {
              path: '/order/aftersale',
              component: () => import('@/view/order/aftersale'),
              name: 'statisticsOrderInfo',
              hidden: true
            },
            {
              path: '/order/aftersale_detail',
              component: () => import('@/view/order/aftersale_detail'),
              name: 'statisticsOrderInfo',
              hidden: true
            },
            {
              path: '/order/offline/list',
              component: () => import('@/view/order/offlineList.vue'),
              name: 'orderOffline',
              hidden: true
            },
            {
              path: '/order/offline/add',
              component: () => import('@/view/order/add-offline'),
              name: 'orderOffline',
              hidden: true
            }
            ]
        },

        {
          path: '/statistics/refund',
          component: () => import('@/view/order/refund'),
          name: 'orderStatistics',
          hidden: true
        },
        {
          path: '/statistics/share-order',
          component: () => import('@/view/statistics/share-order'),
          name: 'orderStatistics',
          hidden: true
        },
        {
          path: '/statistics/consult-order',
          component: () => import('@/view/statistics/consult-order'),
          name: 'orderStatistics',
          hidden: true
        },
        {
          path: '/statistics/doudian-order',
          component: () => import('@/view/statistics/doudian-order'),
          name: 'doudianOrderStatistics',
          hidden: true
        },

        {
          path: '/refund/detail',
          component: () => import('@/view/order/detail'),
          name: 'orderStatistics',
          hidden: true
        },
        {
          path: '/refund/detailNew',
          component: () => import('@/view/order/detailNew'),
          name: 'orderStatistics',
          hidden: true
        },
        {
          path: '/order/givedetail',
          component: () => import('@/view/order/give-detail.vue'),
          name: 'givedetail',
          hidden: true
        },
        {
          path: '/order/complaints',
          component: () => import('@/view/order/complain.vue'),
          name: 'orderComplain',
          hidden: true
        },
        {
          path: '/order/complaindetail',
          component: () => import('@/view/order/complain_detail.vue'),
          name: 'orderComplain',
          hidden: true
        },
        {
          path: '/order/deliver',
          component: () => import('@/view/order/deliver.vue'),
          name: 'orderdeliver',
          hidden: true
        },


      ]
    }
  ]
}

export default statisticsRouter
